import { FC } from 'react';
import { Spinner } from './spinner';
import { ISpinnerOverlayProps } from './spinner-overlay.interface';
import styles from './spinner-overlay.module.scss';

export const SpinnerOverlay: FC<ISpinnerOverlayProps> = ({
  isVisible = true,
  spinnerProps = {}
}) => {

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <Spinner {...spinnerProps} />
    </div>
  );
};
